import "../../Styles/Landing/FAQsL.css";
import { useState } from "react";
import { FAQData } from "../../Assets/Data/FAQData";
import { RiArrowDropRightLine } from "react-icons/ri";

const FAQsL = () => {
  const [activeId, setActiveId] = useState(null);
  const activeItem = FAQData.find((item) => item.id === activeId);
  const handleItemClick = (id) => {
    setActiveId((prevIndex) => (prevIndex === id ? null : id));
  };

  return (
    <section className="fAQsL">
      <h1>FAQs</h1>
      <p>
        Got a question? we are here to answer! if you dont see your question here drop us a line on our{" "}
        <span>contact page</span>
      </p>
      <div className="fAQUnit">
        <div className="fAQQuestions">
          {FAQData.map((item) => (
            <div key={item.id} className={`fAQItem ${activeId === item.id ? "active" : ""}`}>
              <button className="fAQUnitQuestion" onClick={() => handleItemClick(item.id)}>
                {item.question}
                <RiArrowDropRightLine className={`arrow ${activeId === item.id ? "active" : ""}`} />
              </button>
              {activeId === item.id && (
                <div className="fAQUnitSmallAnswer">
                  <p>{activeItem.answer.text}</p>
                  {activeItem.answer.points && (
                    <ul>
                      {activeItem.answer.points.map((point, index) => (
                        <li key={index}>{point}</li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="fAQLargeAnswer">
          {activeItem && (
            <div>
              <p>{activeItem.answer.text}</p>
              {activeItem.answer.points && (
                <ul>
                  {activeItem.answer.points.map((point, index) => (
                    <li key={index}>{point}</li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default FAQsL;
